import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router'
import { ISrsBallotGuidance } from '../../../shared/models/sr/srs-Ballot-guidance';
import { srsVoteOption } from '../../../shared/models/sr/srs-vote';

@Component({
    selector: 'app-srs-ballot-guidance',
    templateUrl: './srs-ballot-guidance.component.html',
    styleUrl: './srs-ballot-guidance.component.scss',
    standalone: false
})
export class SrsBallotGuidanceComponent implements OnInit{
  @Input() modalHeader: string = "";
  @Input() modalText: string = "";

  withdraw = srsVoteOption["SVT_WITHDRAW"];
  reconfirm = srsVoteOption["SVT_RECONFIRM"];
  revise = srsVoteOption["SVT_REVISE"];

   decision_wizard_yes_yes_revise : ISrsBallotGuidance = {
    title: this.revise.text,
    content: "Based on your response, it would be appropriate to 'REVISE' the standard. Please provide more information when you cast your vote and if you would be willing to lead the Project Proposal Development.",
    icon: this.revise.icon,
    iconColor: this.revise.color,
    primaryButtonText: 'Finish',
    secondaryButtonText: null,
    primaryButtonAction: null,
    secondaryButtonAction: undefined,
  }

  decision_wizard_yes_no_reconfirm : ISrsBallotGuidance = {
    title: this.reconfirm.text,
    content: "Based on your response it may be appropriate to 'RECONFIRM' the standard. However, at any point you may submit a proposal to revise the standard if current practise has changed and updates are required. This can include small changes",
    icon: this.reconfirm.icon,
    iconColor: this.reconfirm.color,
    primaryButtonText: 'Finish',
    secondaryButtonText: null,
    primaryButtonAction: null,
    secondaryButtonAction: undefined,
  }

  decision_wizard_yes_no : ISrsBallotGuidance = {
    title: 'Unsure of your decision?',
    content: 'Are significant technical changes required to address critical quality and/or safety issues and the document cannot be used in its current form?',
    icon: '',
    primaryButtonText: 'Yes',
    secondaryButtonText: 'No',
    primaryButtonAction: this.decision_wizard_yes_yes_revise,
    secondaryButtonAction: this.decision_wizard_yes_no_reconfirm,
  }

  decision_wizard_reconfirm : ISrsBallotGuidance = {
    title: this.reconfirm.text,
    content: "Based on your response, it would be appropriate to 'RECONFIRM' the standard.",
    icon: this.reconfirm.icon,
    iconColor: this.reconfirm.color,
    primaryButtonText: 'Finish',
    secondaryButtonText: null,
    primaryButtonAction: null,
    secondaryButtonAction: undefined,
  }

  decision_wizard_yes : ISrsBallotGuidance = {
    title: 'Unsure of your decision?',
    content: 'Is the existing content technically up-​to-​date and fit for purpose?',
    icon: '',
    primaryButtonText: 'Yes',
    secondaryButtonText: 'No',
    primaryButtonAction: this.decision_wizard_reconfirm,
    secondaryButtonAction: this.decision_wizard_yes_no,
  }

  decision_wizard_withdraw : ISrsBallotGuidance = {
    title: this.withdraw.text,
    content: "Based on your response, it may be suitable to 'WITHDRAW' the standard",
    icon: this.withdraw.icon,
    iconColor: this.withdraw.color,
    primaryButtonText: 'Finish',
    secondaryButtonText: null,
    primaryButtonAction: null,
    secondaryButtonAction: undefined,
  }

  decision_wizard : ISrsBallotGuidance = {
    title: 'Unsure of your decision?',
    content: 'Is there still a need for a publication in this area?',
    icon: '',
    primaryButtonText: 'Yes',
    secondaryButtonText: 'No',
    primaryButtonAction: this.decision_wizard_yes,
    secondaryButtonAction: this.decision_wizard_withdraw,
  }

  decision_wizard_intro : ISrsBallotGuidance = {
    title: 'Unsure of your decision?',
    content: 'Are you unsure what action should be taken with this aged publication? If so, then please use this decision wizard for guidance to help you decide if this publication should be Withdrawn, Revised or Reconfirmed.',
    icon: '',
    primaryButtonText: 'Continue',
    secondaryButtonText: 'Cancel',
    primaryButtonAction: this.decision_wizard,
    secondaryButtonAction: null,
  }

  activeStep: ISrsBallotGuidance = this.decision_wizard_intro;

  constructor(public activeModal: NgbActiveModal, private router: Router) {
  }
  ngOnInit(): void {
    this.display = true;
  }

  display: boolean = true;

  primaryButtonClick() {
    if (this.activeStep?.primaryButtonAction != null)
      this.activeStep = this.activeStep?.primaryButtonAction;
    else
      this.close();
  }

  secondaryButtonClick() {
    if (this.activeStep?.secondaryButtonAction != null)
      this.activeStep = this.activeStep?.secondaryButtonAction;
    else
      this.close();
  }

  close() {
    this.activeModal.dismiss('close');
  }

}
